module.exports = __webpack_public_path__ + "static/media/sie-logo-white-rgb.23a678c5.svg";